export default {
  nav: {
    home: 'Startseite',
    rsvp: 'Anmeldung',
    guestbook: 'Gästebuch',
    hotels: 'Unterkunft',
    erlangen: 'Über Erlangen',
    admin: 'Admin',
  },
  home: {
    hero_title: 'Michel feiert seinen 50. Geburtstag!',
    hero_subtitle: 'Ein unvergesslicher Abend · Erlangen · Juli 2026',
    info_cocktail_title: 'Sektempfang',
    info_cocktail_time: '17:00 Uhr',
    info_dinner_title: 'Gala-Abend',
    info_dinner_time: '',
    info_dinner_note: 'Nur Erwachsene',
    info_venue_title: 'Veranstaltungsort',
    info_venue_value: 'Erlangen, Deutschland',
    info_dresscode_title: 'Dresscode',
    info_dresscode_value: 'Eleganz inspiriert von afrikanischer und bayerischer Identität',
    welcome_text:
      'Mit großer Freude lade ich Sie ein, diesen besonderen Moment mit mir zu feiern. Ihre Anwesenheit ist das schönste Geschenk.',
    cta_rsvp: 'Anmeldung bestätigen',
    hero_eyebrow: "Einladung zu meinem",
    hero_title_word: "Geburtstag",
    hero_motto: "Ich war nie allein!",
    hero_date: "SAMSTAG · 11. JULI 2026 · ERLANGEN",
    hero_children_note: "So sehr ich Kinder liebe — der Gala-Abend ist nur für Erwachsene",
    hero_venue: "Sieboldstr. 3 · 91052 Erlangen",
    hero_deadline: "Rückmeldung bis 07. Juni 2026",
  },
  rsvp: {
    title: 'Anmeldung bestätigen',
    subtitle: 'Bitte füllen Sie dieses Formular bis zum 1. Juni 2026 aus',
    first_name: 'Vorname *',
    last_name: 'Nachname *',
    email: 'E-Mail',
    phone: 'Telefon',
    attendance: 'Teilnahme',
    attendance_solo: 'Ich komme allein',
    attendance_with_guest: 'Ich komme mit einer Begleitung',
    attendance_no: 'Nein, ich kann leider nicht kommen',
    dietary_needs:
      'Besondere Bedürfnisse (Ernährung, eingeschränkte Mobilität, etc.)',
    message: 'Persönliche Nachricht (optional)',
    gdpr_consent:
      'Ich stimme zu, dass meine Daten ausschließlich für die Organisation dieser Veranstaltung verwendet werden (DSGVO) *',
    submit: 'Anmeldung bestätigen',
    success_title: 'Vielen Dank für Ihre Bestätigung!',
    success_text:
      'Ihre Teilnahme wurde erfolgreich registriert. Bis bald!',
    error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    required_fields: 'Bitte füllen Sie alle Pflichtfelder aus.',
    code_title: "Einladungscode",
    code_subtitle: "Gib den Code ein, den du mit deiner Einladung erhalten hast",
    code_label: "Einladungscode *",
    code_placeholder: "XXXXXX",
    code_validate: "Code prüfen",
    code_validated: "Code bestätigt",
    code_invalid: "Ungültiger oder bereits verwendeter Code",
    code_error: "Fehler bei der Code-Überprüfung",
  },
  guestbook: {
    title: 'Gästebuch',
    subtitle: 'Hinterlassen Sie eine Nachricht für Michel',
    name: 'Ihr Name *',
    message: 'Ihre Nachricht *',
    submit: 'Nachricht veröffentlichen',
    success: 'Danke! Ihre Nachricht wird nach Prüfung veröffentlicht.',
    error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    no_messages: 'Noch keine Nachrichten. Seien Sie der Erste!',
    messages_title: 'Die Nachrichten',
  },
  admin: {
    title: 'Administrationsbereich',
    login_title: 'Anmeldung',
    username: 'Benutzername',
    password: 'Passwort',
    login_btn: 'Anmelden',
    login_error: 'Falsche Anmeldedaten',
    logout: 'Abmelden',
    guests_tab: 'Gäste',
    guestbook_tab: 'Gästebuch',
    codes_tab: 'Codes',
    codes_total: 'Codes gesamt',
    codes_used: 'Verwendet',
    codes_available: 'Verfügbar',
    codes_generate: '200 Codes generieren',
    codes_export: 'CSV exportieren',
    codes_delete_unused: 'Unbenutzte löschen',
    codes_delete_confirm: 'Alle unbenutzten Codes löschen? Diese Aktion ist unwiderruflich.',
    codes_generated: 'Codes generiert',
    code_col: 'Code',
    code_status_col: 'Status',
    code_used_at_col: 'Verwendet am',
    code_available: 'Verfügbar',
    code_used: 'Verwendet',
    total_guests: 'Anmeldungen',
    attending_count: 'Kommen',
    not_attending_count: 'Kommen nicht',
    export_csv: 'CSV exportieren',
    approve: 'Genehmigen',
    hide: 'Verstecken',
    status_approved: 'Genehmigt',
    status_pending: 'Ausstehend',
    name_col: 'Name',
    email_col: 'E-Mail',
    plus_ones_col: 'Begleiter',
    attending_col: 'Teilnahme',
    dietary_col: 'Bedürfnisse',
    date_col: 'Datum',
    yes: 'Ja',
    no: 'Nein',
  },
  privacy: {
    title: 'Datenschutzerklärung',
    content: `**Datenerhebung**

Im Rahmen der Organisation dieser privaten Veranstaltung erheben wir folgende Informationen: Vor- und Nachname, Kontaktdaten, Teilnahmepräferenzen und besondere Bedürfnisse.

**Datenverwendung**

Diese Daten werden ausschließlich für die Organisation von Michels 50. Geburtstag (Juli 2026, Erlangen) verwendet. Sie werden in keinem Fall an Dritte weitergegeben.

**Aufbewahrung**

Die Daten werden 6 Monate nach der Veranstaltung gelöscht.

**Rechte**

Gemäß DSGVO haben Sie das Recht auf Zugang, Berichtigung und Löschung Ihrer Daten. Um diese Rechte auszuüben, wenden Sie sich an den Veranstalter.

**Verantwortlicher**

Private Veranstaltung · Erlangen · 2026`,
  },
  erlangen: {
    tag: 'Reisetipps',
    title: 'Erlangen entdecken',

    shopping_title: 'Shopping in Herzogenaurach: Heimat von Adidas und Puma',
    shopping_intro:
      'Nur einen Katzensprung von Erlangen entfernt liegt Herzogenaurach, der Geburtsort der Sportartikelgiganten Adidas und Puma. Für Shopping-Begeisterte bieten die dortigen Outlets eine ideale Anlaufstelle für Markenartikel zu attraktiven Preisen.',
    shopping_addresses: 'Wichtige Adressen für Ihren Shopping-Ausflug:',
    shopping_adidas: 'adidas Outlet Store: Olympiaring 2, 91074 Herzogenaurach',
    shopping_puma: 'PUMA Outlet: Puma Way 1, 91074 Herzogenaurach',
    shopping_others: 'Weitere Marken-Outlets: Diese finden sich konzentriert in der Zeppelinstraße (z. B. s.Oliver).',
    shopping_note:
      'Hinweis: Die meisten Outlets haben montags bis freitags von 09:00 bis 20:00 Uhr und samstags bis 18:00 oder 19:00 Uhr geöffnet. Bitte prüfen Sie vorab die aktuellen Öffnungszeiten der jeweiligen Filialen.',

    culture_title: 'Kultur und Kulinarisches',
    culture_intro:
      'Erlangen ist für seine tiefe Biergartenkultur bekannt, die besonders im Sommer zum Verweilen einlädt. Ob traditionell unter schattigen Bäumen oder direkt an der Regnitz — die lokale Braukunst und fränkische Schmankerl gehören zum Pflichtprogramm.',
    culture_subtitle: 'Empfehlenswerte Biergärten und Keller',
    biergaerten: [
      {
        name: 'Steinbach Bräu',
        desc: 'Historischer Brauereigarten mitten in der Stadt, bekannt für kreative Biere und Klassiker wie Schäufele oder Bratwurst. Besonderes Highlight: die Storchen-Webcam.',
        url: 'https://steinbach-braeu.de',
      },
      {
        name: 'Entlas-Keller',
        desc: 'Rustikaler Klassiker in der bekannten Erlanger Keller-Gegend. Schattige Atmosphäre, breites Angebot an regionalen Spezialitäten, sehr familienfreundlich.',
        url: 'https://entlaskeller.de',
      },
      {
        name: 'Kitzmann Bräuschänke',
        desc: 'Klassischer Biergarten mit rustikaler Einrichtung. Speisekarte mit traditionellen Gerichten wie Haxe und Schnitzelvarianten.',
        url: null,
      },
      {
        name: 'Gaststätte am Röthelheim',
        desc: 'Zentral gelegener Biergarten mit begrünter Umgebung und vielfältiger Karte — fränkische Küche sowie vegetarische und vegane Optionen.',
        url: 'https://www.gaststätte-am-röthelheim.de',
      },
      {
        name: 'Thalermühle',
        desc: 'Historisch geprägtes Lokal mit schönem Außenbereich und guter Servicequalität. Ideal für entspannte Abende, kleine Gerichte zum Teilen.',
        url: null,
      },
    ],

    siemens_title: 'Erlangen – Die Siemens-Stadt',
    siemens_text:
      'Erlangen ist weltweit eng mit der Siemens AG verbunden, die hier ihren größten Entwicklungs- und Verwaltungsstandort betreibt. Als bedeutendes Zentrum für Forschung und Technologie prägt die Stadt die Region maßgeblich. Ein Spaziergang entlang der Siemenspromenade vermittelt einen Eindruck von der wirtschaftlichen Stärke des Standorts.',

    vacation_title: 'Für Urlaub planen',
    vacation_text:
      'Um die vielfältigen Facetten der Metropolregion Nürnberg in aller Ruhe zu entdecken, lohnt es sich, etwas mehr Zeit einzuplanen und den Besuch mit einem kleinen Urlaub zu verbinden.',
  },
  hotels: {
    tag: 'Unterkunft',
    title: 'Hotels in Erlangen',
    intro: "Für Ihren Aufenthalt in Erlangen haben wir untenstehende Hotels aufgelistet. Sie befinden sich im Umkreis von 4 km von der Feierlocation (Sieboldstr. 3, 91052 Erlangen).",
    platforms_note: 'Wir empfehlen außerdem, auch die Plattformen',
    or: 'oder',
    platforms_suffix: 'für weitere Details und Verfügbarkeiten zu nutzen.',
    reference: 'Referenz: Sieboldstr. 3, 91052 Erlangen · Umkreis 4 km',
    col_rang: '#',
    col_name: 'Hotel',
    col_address: 'Adresse',
    col_distance: 'Entfernung',
    col_min: 'Min-Preis',
    col_max: 'Max-Preis',
    col_note: 'Besonderheit',
    price_note: 'Die Preise sind Richtwerte und können je nach Saison und Verfügbarkeit variieren.',
  },
  common: {
    loading: 'Laden...',
    back: 'Zurück',
  },
};
